import { IconClose, IconMenu } from "@/components/icons/Icon";
import { ROUTE_IDS, type RouteId } from "@/routing/routes";
import { useHashRoute } from "@/routing/useHashRoute";
import "./GlobalHeader.css";

const NAV: { id: RouteId; number: string; label: string }[] = [
  { id: "stellar", number: "01", label: "Stellar" },
  { id: "earth2", number: "02", label: "Earth 2.0" },
  { id: "stars", number: "03", label: "I Eat the Stars" },
  { id: "earth3", number: "04", label: "Earth 3.0" },
  { id: "practice", number: "05", label: "Practice" },
  { id: "sources", number: "06", label: "Evidence" },
];

type Props = {
  mobileNavOpen: boolean;
  onToggleMobileNav: () => void;
};

export function GlobalHeader({ mobileNavOpen, onToggleMobileNav }: Props) {
  const { route, navigate } = useHashRoute();

  return (
    <header className="global-header botanical-glass" role="banner">
      <a
        className="brand"
        href="#field"
        onClick={(e) => {
          e.preventDefault();
          navigate("field");
        }}
      >
        <span className="brand-name">Nicole Lockwood</span>
        <span className="brand-sep" aria-hidden="true">
          /
        </span>
        <span className="brand-product">Earth 3.0</span>
      </a>

      <button
        type="button"
        className="nav-menu-toggle"
        aria-expanded={mobileNavOpen}
        aria-controls="global-nav"
        onClick={onToggleMobileNav}
      >
        {mobileNavOpen ? <IconClose size={22} /> : <IconMenu size={22} />}
        <span className="visually-hidden">{mobileNavOpen ? "Close menu" : "Open menu"}</span>
      </button>

      <nav
        id="global-nav"
        className={["global-nav", mobileNavOpen ? "is-open" : ""].join(" ")}
        aria-label="Chapters"
      >
        {NAV.map((item) => {
          const active = route === item.id;
          return (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="nav-button"
              aria-current={active ? "page" : undefined}
              onClick={(e) => {
                e.preventDefault();
                navigate(item.id);
                if (mobileNavOpen) onToggleMobileNav();
              }}
            >
              <span className="nav-number">{item.number}</span>
              <span className="nav-label">{item.label}</span>
            </a>
          );
        })}
      </nav>

      <span className="visually-hidden">
        Routes: {ROUTE_IDS.map((id) => `#${id}`).join(", ")}
      </span>
    </header>
  );
}
